import { render, staticRenderFns } from "./SiblingCompanyTable.vue?vue&type=template&id=8f6ce756&scoped=true&"
import script from "./SiblingCompanyTable.vue?vue&type=script&lang=js&"
export * from "./SiblingCompanyTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f6ce756",
  null
  
)

export default component.exports